var filters = {
    deparment: 'deparment',
    institution: 'institution',
    deparmentDetail: 'deparment_detail'
};

var ProjectHeader = React.createClass({
    ref: function () {
        return 'institucionales/' + this.props.year;
    },

    handleChange: function (id) {
        return this.props.handlerBack(id);
    },

    humanizeInt: function (data) {
        var number = data / 1000000.0;
        return Humanize.formatNumber(number, 2);
    },

    renderProjects: function () {
        var self = this;
        var projects = this.props.projects.map(function (item) {
            return (
                <a href="javascript:;" className="dropdown-item" onClick={self.handleChange.bind(this, item.year)} >
                    {item.year} - {item.project_status}
                </a>
            );
        });
        return projects;
    },

    getDescription: function (description) {
        if ( description ) {
            return description;
        } else {
            return 'Contiene todos los proyectos de inversión que realizan las diferentes instituciones del sector público, financiados con los ingresos del gobierno de Nicaragua o con fondos propios de empresas estatales.';
        }
    },

    render: function () {
        var project = this.props.project;
        return (
            <section>
                <section className="page-header image-gastos mt15">
                    <h2 className="section-title">{project.name}</h2>
                    <p className="fsize14">
                        {this.getDescription(project.description)}
                    </p>
                </section>
                <ul className="nav nav-pills nav-card nav-card-projects mt15 flex">
                    <li className="nav-item">
                      <a className="nav-link nav-title">PROYECTOS</a>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-calendar-o" aria-hidden="true"></i> {project.year}</a>
                        <div className="dropdown-menu">
                            {this.renderProjects()}
                        </div>
                    </li>
                    <li className="nav-item nav-filter">
                        <nav className="nav-filter__container">
                            <div className="nav-link nav-filter__name">
                                <span>FILTROS</span>
                                <i className="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                            <ul className="nav-filter__options">
                                <li className="nav-filter__item">
                                    <input type="radio" id="deparment" name="filter" value="deparment" checked="checked" />
                                    <label htmlFor="deparment" onClick={this.props.handlerFilter.bind(this, filters.deparment)} >DEPARTAMENTO</label>
                                    <div className="nav-filter__radio"></div>
                                </li>
                                <li className="nav-filter__item">
                                    <a href={this.ref()}>
                                        <input type="radio" id="institution" name="filter" value="institution" />
                                        <label>
                                            <a href={this.ref()}>INSTITUCIÓN</a>
                                        </label>
                                        <div className="nav-filter__radio"></div>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link nav-total" >TOTAL C$: <em>{this.humanizeInt(this.props.totalLabel)} millones</em></a>
                    </li>
                </ul>
            </section>
        )
    }
});

var ProjectParentList = React.createClass({

    getAttrs: function (value, prefix) {
        return prefix + value;
    },

    getDescription: function ( description, filter ) {
        if ( filter == filters.deparment ) {
            return '';
        } else if ( filter == filters.institution ) {
            return (
                <div>
                    <div className="card-description">{description}</div>
                    <p className="card-text nm">{description}</p>
                </div>
            );
        }
    },

    cardClass: function (total) {
        if ( this.props.filterBy == filters.deparment ) {
            if ( total == 0 ) {
                return 'card card-list show-deparment-detail hide';
            } else {
                return 'card card-list show-deparment-detail';
            }
        } else if ( this.props.filterBy == filters.institution ) {
            return 'card card-list show-in-detail';
        }
    },

    destroyTable: function () {
        if ( this.props.filterBy == filters.institution ) {
            var table = $('#table-' + this.props.parent).DataTable();
            table.destroy();
        }
    },

    handlerDetail: function ( id, filter ) {
        if ( filter == filters.deparment ) {
            var chart = $('#chart').highcharts();
            if ( chart ) {
                $.each(mapNicaragua, function(i){
                    if ( this.pk == id ) {
                        chart.series[0].data[i].doDrilldown();
                    }
                });
            }
        }
        return this.props.handlerDetail(id, filter);
    },

    humanizeInt: function (data) {
        var number = data / 1000000.0;
        return Humanize.formatNumber(number, 2);
    },

    percentage: function (rest, total) {
        return Number(((rest / total) * 100).toFixed(2))
    },

    percentageClass: function (rest, total) {
        var percentage = parseInt((rest / total) * 100);
        var name = 'progress-percentage progress-' + percentage;
        return name;
    },

    renderColumns: function (parentList) {
        var self = this;
        var projectTotal =  this.props.projectTotal
        var parents = parentList.map(function (item) {
                return (
                    <div className="col-sm-12">
                        <div className={self.cardClass(item.total)} role="tab" id={self.getAttrs(item.id, 'head-')} onClick={self.handlerDetail.bind(this, item.parent_id, item.filter)} >
                            <div className="card-content" data-toggle="collapse" data-parent="#accordion" data-target={self.getAttrs(item.id, '#ins-')} aria-controls={self.getAttrs(item.id, 'ins-')} aria-expanded="false">
                                <div className="row flex">
                                    <div className="col-xs-12 col-sm-5 border-right flex-align-center">
                                        <div className="card-block">
                                            <h4 className="card-title text-uppercase">{item.name}</h4>
                                            {self.getDescription(item.description, self.props.filterBy)}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2 text-center border-right flex-center">
                                        <div className="card-block">
                                            <h4 className="card-title">TOTAL C$</h4>
                                            <p className="nm">{self.humanizeInt(item.total)} millones</p>

                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-5 flex-center">
                                        <div className="card-block full">
                                            <div className="progress-content">
                                                <div className={self.percentageClass(item.total, projectTotal)}>
                                                    <div className="progress-tooltip">
                                                        <span>{self.percentage(item.total, projectTotal)}%</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-button">
                                    <button type="button">Mas datos <i className="fa fa-chevron-down" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="show-data collapse" id={self.getAttrs(item.id, 'ins-')} role="tabpanel" aria-expanded="false" aria-labelledby={self.getAttrs(item.id, 'head-')}>
                            <div className="card simple-card">
                                <div className="show-assignments">

                                </div>
                            </div>
                        </div>
                    </div>
                );
        });

        return parents;
    },

    render: function () {
        var self = this;
        return (
            <div className="row " id="accordion" role="tablist" aria-multiselectable="true">
                {this.renderColumns(this.props.parentList)}
            </div>
        )
    }
});

var ProjectMulti = React.createClass({

    render: function () {
        return (
            <div className="p-relative">
                <button type="button" className="btn btn-orange btn-upcase button-special" onClick={this.props.handler.bind(this, 'listview')}>Regresar a Proyectos</button>
            </div>
        );
    }
});

var ProjectMain = React.createClass({
    getInitialState: function () {
        return {
            project: {},
            year: this.props.year,
            dataUrl: this.props.dataUrl,
            detailUrl: this.props.detailUrl,
            projects_years: [],
            parentList: [],
            detail: [],
            detailView: false,
            deparmentActive: {},
            deparmentActiveName: "",
            status: 200,
            view_type: 'listview',
            parentActive: 0,
            filter_by: filters.deparment,
            loading: true,
            container: 'table-react',
            municipality: false,
            municipality_id: null,
            parent_department: null
        }
    },

    componentDidMount: function () {
        this.loadData(this.state.year, this.state.view_type, this.state.filter_by);
    },

    handleClick: function (year) {
        this.setState({year: year}, function(){
            if(this.state.detailView == true) {
                var id = this.state.municipality ? this.state.municipality_id : this.state.parent_department;
                this.loadDetail(id, this.state.filter_by, true, this.state.municipality)
            }
        });
        this.loadData(year, this.state.view_type, this.state.filter_by);
    },

    handleViewType: function ( viewType ) {
        this.setState({ view_type: viewType });
        this.loadData(this.state.year, viewType, this.state.filter_by);
    },

    handleFilterClick: function ( filter ) {
        this.setState({ filter_by: filter, loading: true });
        this.loadData(this.state.year, this.state.view_type, filter);
    },

    handlerDetail: function( id, filter) {

        if ( filter == filters.deparment ) {
            if(this.state.detailView == true){
              this.setState({municipality : true, municipality_id: id});
            }
            else{
              this.setState({detailView:true , parent_department: id});
            }
        }
        else if ( filter == filters.institution ) {
            this.setState({ parentActive: id, filter_by: filter });
        }
        this.loadDetail(id, filter, true , this.state.municipality);
   },

    handlerBack: function () {
        //debugger;

        if(this.state.municipality == true){
          this.loadDetail(this.state.parent_department, this.state.filter_by, true , false);
          this.setState({municipality:false});
        }
        else{
          this.setState({ detailView: false });

          if ( this.state.filter_by == filters.deparment ) {
              var chart = $('#chart').highcharts();
              if ( chart ) {
                  chart.drillUp();
              }
          }

        }

        if ( this.state.filter_by == filters.deparment ) {

          var chart = $('#chart').highcharts();
          var selectedPoints = chart.getSelectedPoints();

          for(var i = 0; i < selectedPoints.length; i++){
            selectedPoints[i].select();
          }

        }

        var dataGrid = this.props.dataGrid;
        $(dataGrid.grid[0]).parent().css({'visibility': 'hidden', 'height': '0', 'overflow': 'hidden'});
    },

    loadData: function (year, view_type, filter_by) {
        //debugger;
        var url = this.state.dataUrl + '?view_type=' + view_type + '&filter_by=' + filter_by + '&year=' + year + '&detailView=' + this.state.detailView + '&municipality=' + this.state.municipality;
        var self = this;
        var multiDeparmentGrid = this.props.multiDeparmentGrid;
        var data;
        if ( view_type == 'listview' ) {
            $.getJSON(url, function ( data ) {
                self.setState({
                    project: data.project,
                    projects_years: data.projects_years,
                    parentList: data.parentList,
                    status: data.status,
                    loading: false,
                });
                $(multiDeparmentGrid.grid[0]).parent().css({'visibility': 'hidden', 'height': '0', 'overflow': 'hidden', 'margin-top': '0px', 'margin-bottom':'0px'});
            });
        } else if ( view_type == 'multidepartamental' ) {
            $.getJSON(url, function ( data ) {
                self.setState({
                    project: data.project,
                    projects_years: data.projects_years,
                    //parentList: data.parentList,
                    status: data.status,
                    loading: false,
                });
                multiDeparmentGrid.update(data.parentList);
                if(year > 2018){
                    multiDeparmentGrid.showColumn('name')
                } else{
                    multiDeparmentGrid.hideColumn('name')
                }
                $(multiDeparmentGrid.grid[0]).parent().css({'visibility': 'visible', 'height': 'auto', 'overflow': 'auto', 'margin-top': '80px', 'margin-bottom':'30px'});
            });

        }
    },

    loadDetail: function (id, filter, detailView , municipality) {
        var self = this;
        var dataGrid = self.props.dataGrid;
        var url = this.state.detailUrl + '?year=' + this.state.year + '&parent_id=' + id + '&filter_by='+ filter + '&detailView=' + detailView + '&municipality=' + municipality;
        var year = this.state.year;
        $.getJSON( url, function ( item ) {
            self.setState({ deparmentActive: item.deparmentActive  , deparmentActiveName: item.name});
            if (year > 2018){
                dataGrid.showColumn('name');
            } else {
                dataGrid.hideColumn('name');
            }
            dataGrid.update(item.detail);
            $(dataGrid.grid[0]).parent().css({'visibility': 'visible', 'height': 'auto', 'overflow': 'auto'});
        });

    },

    scroll : function () {
      this.props.dataGrid.grid[0].scrollIntoView({ behavior: 'smooth',
          block: 'start',});
    },

    senderDetailInstitution: function () {
        if ( this.state.filter_by == filters.institution ) {
            return this.state.detail;
        } else {
            return {}
        }
    },

    mainClassName: function () {
        if ( this.state.loading == false ) {
            return 'main mt20';
        } else if ( this.state.loading == true ) {
            return 'main mt20 loading-projects';
        }
    },

    buttonMultidepartamental: function () {
        if ( this.state.detailView == false ) {
            return (
                <button type="button" className="btn btn-orange btn-upcase button-special" onClick={this.handleViewType.bind(this, 'multidepartamental')}><span>Ver Proyectos</span> Multidepartamentales</button>
            );
        }
    },

    CurrentlyViewingSpan: function () {
        if ( this.state.detailView == true ) {
            return (
                  <button type="button" className="btn btn-orange btn-upcase button-special" onClick = {this.scroll} ><span>Ver Proyectos de</span> {this.state.deparmentActiveName}</button>
            );
        }
    },


    downloadButton: function () {
        var url = this.props.downloadUrl + this.state.project.id;
        return <a href={url} className="btn btn-primary">Descargar base de datos</a>;
    },

    totalLabel: function () {
        if ( this.state.detailView == false ) {
          return this.state.project.total;
        } else {
          return this.state.deparmentActive.total;
        }
    },

    renderMap: function () {
        if ( this.state.filter_by == filters.deparment ) {
            return (
                <div className="map-container mb30">
                    {this.downloadButton()}
                    <ProjectMap handlerMap={this.handlerDetail.bind(this)}/>
                    {this.buttonMultidepartamental()}
                    {this.CurrentlyViewingSpan()}
                </div>
            );
        }
    },

    isParentOrChild: function () {
        if ( this.state.detailView ) {
            //this.createTable();
            return(
                <div>
                    <button className="btn btn-primary pull-right mb30" onClick={this.handlerBack.bind(this)}>Volver</button>
                </div>
            );

        } else {
            return <ProjectParentList parentList={this.state.parentList} filterBy={this.state.filter_by} handlerDetail={this.handlerDetail.bind(this)} detail={this.senderDetailInstitution()} parent={this.state.parentActive} projectTotal={this.state.project.total} />
        }
    },

    renderProjects: function () {
        if ( this.state.view_type == 'listview' ) {
            return (
                <section className="mb30">
                    {this.renderMap()}
                    {this.isParentOrChild()}
                </section>
            );
        } else if ( this.state.view_type == 'multidepartamental' ) {
            return <ProjectMulti info={this.state.parentList} handler={this.handleViewType} />;
        }
    },

    render: function () {
        return (
            <main className={this.mainClassName()}>
                <div className="iep-container">
                    <ProjectHeader year={this.state.year} project={this.state.project} projects={this.state.projects_years} handlerFilter={this.handleFilterClick} handlerBack={this.handleClick.bind(this)} totalLabel={this.totalLabel()} />
                    {this.renderProjects()}
                </div>
            </main>
        )
    }
});

var ProjectApp = React.createClass({
    render: function () {
        return (
            <div className="projectapp-container">
                <nav className="breadcrumb pl0">
                    <div className="iep-container">
                        <a className="breadcrumb-item" href="/">Observatorio</a>
                        <a href="#" className="breadcrumb-item active">Proyectos Departamentales y Municipales</a>
                    </div>
                </nav>
                <ProjectMain year={this.props.year} dataGrid={this.props.dataGrid} dataUrl={this.props.dataUrl} detailUrl={this.props.detailUrl} multiDeparmentGrid={this.props.multiDeparmentGrid} downloadUrl={this.props.downloadUrl} />
            </div>
        )
    }
});
